/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import Translation from 'generics/Translation'
import { Col, Row } from 'reactstrap'
import { Card, Main } from 'generics/Card'
import classNames from 'classnames'
import { I18N } from 'constants/props'
import StyledButton from 'generics/StyledFormComponents/StyledButton/StyledButton'
import { Link, withRouter } from 'react-router-dom'
import { formatRoute } from 'react-router-named-routes'
import { ADMINISTRATION } from 'constants/urls'
import PropTypes from 'prop-types'

import styles from './MyNetworkLimitedMembers.scss'

const { PUBLIC_PATH } = process.env

const NETWORK_PROFILE_IMAGE = `${window.location.origin}${PUBLIC_PATH}/network/network-profile.png`
const NETWORK_OVERVIEW_IMAGE = `${window.location.origin}${PUBLIC_PATH}/network/overview.png`
const NETWORK_CONNECTIONS_IMAGE = `${window.location.origin}${PUBLIC_PATH}/network/my-connections.png`
const NETWORK_LEADERSHIP_IMAGE = `${window.location.origin}${PUBLIC_PATH}/network/leadership.png`

/**
 * My Network Component for Limited Members
 * @extends Component
 */

const MyNetWorkLimitedMembers = ({ accountId, i18n }) => {
  return (
    <div>
      <Card
        barClassName={styles.bar}
        className={classNames(styles.card, styles.sectionOne)}
        data-test-component="my-network-limited-members"
      >
        <Main>
          <Row>
            <Col xs="12" md="6" className={classNames(styles.left)}>
              <h1 className={`${styles.title} ${styles.padding12}`}>{i18n.network.limitedMember.sectionOne.title}</h1>
              <div className={`epic ${styles.padding12}`}>
                <p className={styles.description}>{i18n.network.limitedMember.sectionOne.description}</p>
              </div>
              <div className={styles.buttonWrap}>
                <Link
                  href={formatRoute(ADMINISTRATION, { accountId, sectionId: 'people' })}
                  title={i18n.network.limitedMember.upgrageToPro}
                  to={formatRoute(ADMINISTRATION, { accountId, sectionId: 'people' })}
                >
                  <StyledButton
                    color="primary"
                    title={i18n.network.limitedMember.upgrageToPro}
                    className={classNames(styles.button)}
                  >
                    {i18n.network.limitedMember.upgrageToPro}
                  </StyledButton>
                </Link>
              </div>
            </Col>
            <Col xs="12" md="6">
              <div className={classNames(styles.imageContainer)}>
                <img
                  alt={i18n.network.limitedMember.sectionOne.title}
                  className={classNames(styles.image)}
                  src={NETWORK_PROFILE_IMAGE}
                />
              </div>
            </Col>
          </Row>
        </Main>
      </Card>
      <Card
        barClassName={styles.bar}
        className={classNames(styles.card, styles.sectionTwo)}
        data-test-component="my-network-limited-members"
      >
        <Main>
          <Row>
            <Col xs="12" md="12" className={classNames(styles.top)}>
              <h1 className={`${styles.title} ${styles.padding12}`}>{i18n.network.limitedMember.sectionTwo.title}</h1>
              <div className={`epic ${styles.padding12}`}>
                <p className={styles.description}>{i18n.network.limitedMember.sectionTwo.description}</p>
              </div>
              <div className={styles.buttonWrap}>
                <Link
                  href={formatRoute(ADMINISTRATION, { accountId, sectionId: 'people' })}
                  title={i18n.network.limitedMember.upgrageToPro}
                  to={formatRoute(ADMINISTRATION, { accountId, sectionId: 'people' })}
                >
                  <StyledButton
                    color="primary"
                    title={i18n.network.limitedMember.upgrageToPro}
                    className={classNames(styles.button)}
                  >
                    {i18n.network.limitedMember.upgrageToPro}
                  </StyledButton>
                </Link>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="4" lg="4" className={classNames(styles.col_second)}>
              <div className={classNames(styles.imageContainer)}>
                <img
                  alt={i18n.network.limitedMember.sectionTwo.title}
                  className={classNames(styles.image)}
                  src={NETWORK_OVERVIEW_IMAGE}
                />
              </div>
            </Col>
            <Col xs="12" md="4" lg="4" className={classNames(styles.col_second)}>
              <div className={classNames(styles.imageContainer)}>
                <img
                  alt={i18n.network.limitedMember.sectionTwo.title}
                  className={classNames(styles.image)}
                  src={NETWORK_CONNECTIONS_IMAGE}
                />
              </div>
            </Col>
            <Col xs="12" md="4" lg="4" className={classNames(styles.col_second)}>
              <div className={classNames(styles.imageContainer)}>
                <img
                  alt={i18n.network.limitedMember.sectionTwo.title}
                  className={classNames(styles.image)}
                  src={NETWORK_LEADERSHIP_IMAGE}
                />
              </div>
            </Col>
          </Row>
        </Main>
      </Card>
    </div>
  )
}

MyNetWorkLimitedMembers.propTypes = {
  accountId: PropTypes.number.isRequired,
  i18n: I18N.isRequired,
}

export default withRouter(Translation(MyNetWorkLimitedMembers, ['network']))
